import { render, staticRenderFns } from "./DocumentsManagement.vue?vue&type=template&id=2b67a3ee&scoped=true&"
import script from "./DocumentsManagement.vue?vue&type=script&lang=js&"
export * from "./DocumentsManagement.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsManagement.vue?vue&type=style&index=0&id=2b67a3ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67a3ee",
  null
  
)

export default component.exports